import type { DocumentTag } from "@/constants/Documents";
import { ModalPath } from "@/constants/Navigation";

enum TasksStatusId {
  Done = 3,
  InProgress = 2,
  ToDo = 1,
}

enum TaskStatusLabel {
  Closed = "Closed",
  Done = "Done",
  InProgress = "In progress",
  ToDo = "To do",
  Void = "Void",
}

enum TaskCategory {
  PatientCare = "Patient care",
}

const TaskSubcategory: Record<string, TaskSubcategory> = {
  All: "All",
  ConsentForms: "Consent forms",
  InsuranceVerification: "Insurance verification",
  IntakeSurvey: "Intake survey",
  LabDocuments: "Lab documents",
  MedicalClearance: "Medical clearance",
  MedicalRecordsCoordination: "Medical records coordination",
  ProviderAssignment: "Provider assignment",
  SubCategoryTypeAssessment: "Assess",
  Vitals: "Vitals",
};

const TaskSubcategoryToModalPathMap: Partial<
  Record<TaskSubcategory, ValueOf<typeof ModalPath>>
> = {
  [TaskSubcategory.All]: ModalPath.AssessmentTask,
  [TaskSubcategory.ConsentForms]: ModalPath.SignFormsTask,
  [TaskSubcategory.InsuranceVerification]: ModalPath.UploadInsuranceTask,
  [TaskSubcategory.IntakeSurvey]: ModalPath.AssessmentTask,
  [TaskSubcategory.LabDocuments]: ModalPath.LabRequest,
  [TaskSubcategory.MedicalClearance]: ModalPath.MedicalEvaluationTask,
  [TaskSubcategory.MedicalRecordsCoordination]: ModalPath.SignFormsTask,
  [TaskSubcategory.SubCategoryTypeAssessment]: ModalPath.AssessmentTask,
  [TaskSubcategory.Vitals]: ModalPath.LogWeightTask,
};

type TaskUploadFileV2Params = {
  documentTags: DocumentTag[];
  file: File;
  fileName: string;
  fileSize: string;
  patientExternalId: string;
};

export {
  TaskCategory,
  TasksStatusId,
  TaskStatusLabel,
  TaskSubcategory,
  TaskSubcategoryToModalPathMap,
};

export type { TaskUploadFileV2Params };
